import React, { useEffect, useState } from "react";

export default function Speakers() {
  const [speakers, setSpeakers] = useState([]);

  useEffect(() => {
    fetch("/data/speakers.json")
      .then(res => res.json())
      .then(data => setSpeakers(data));
  }, []);

  return (
    <section id="speakers" className="text-white py-5">
      <div className="container">
        <h2 className="text-center mb-5">Speakers</h2>
        <div className="row justify-content-center g-4">
          {speakers.map((speaker, index) => (
            <div className="col-md-6 col-lg-4 d-flex" key={index}>
              <div className="card profile-card shadow bg-dark text-white w-100 h-100">
                <div className="card-body text-left d-flex flex-column">
                  <img
                    src={`/image/${speaker.image}`}
                    alt={speaker.name}
                    className="rounded-circle mb-3 mx-auto"
                    style={{ width: "200px", height: "200px", objectFit: "cover" }}
                  />

                  {/* Name */}
                  <h4 className="fw-bold mb-1 text-center" style={{ color: '#FFFFFF' }}>
                    {speaker.name}
                  </h4>

                  {/* Career */}
                  <h5 className="fw-normal mb-3 text-center" style={{ color: '#FFD166' }}>
                    {speaker.role}
                  </h5>

                  {/* Biography */}
                  <h6 className="fw-bold text-light mt-3">Biography</h6>
                  <p className="text-sm small text-light mb-2" style={{ whiteSpace: "pre-line" }}>
                    {speaker.description}
                  </p>

                  {/* Education & Expertise */}
                  {speaker.education && (
                    <>
                      <h6 className="fw-bold text-light mt-3">Education & Expertise</h6>
                      <p className="fst-italic text-white small mb-2" style={{ whiteSpace: "pre-line" }}>
                        {speaker.education}
                      </p>
                    </>
                  )}

                  {/* Topic */}
                  {speaker.title && (
                    <>
                      <h6 className="fw-bold text-light mt-3">Topic</h6>
                      <p className="text-white small mb-2">{speaker.title}</p>
                    </>
                  )}

                  {/* Contact Icons */}
                  <div className="mt-auto pt-3 text-center">
                    {speaker.email && (
                      <a
                        href={`mailto:${speaker.email}`}
                        className="text-white mx-2"
                        title="Email"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fas fa-envelope fa-lg"></i>
                      </a>
                    )}
                    {speaker.facebook && (
                      <a
                        href={speaker.facebook}
                        className="text-white mx-2"
                        title="Facebook"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fab fa-facebook fa-lg"></i>
                      </a>
                    )}
                    {speaker.instagram && (
                      <a
                        href={speaker.instagram}
                        className="text-white mx-2"
                        title="Instagram"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fab fa-instagram fa-lg"></i>
                      </a>
                    )}
                    {speaker.linkedin && (
                      <a
                        href={speaker.linkedin}
                        className="text-white mx-2"
                        title="LinkedIn"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fab fa-linkedin fa-lg"></i>
                      </a>
                    )}
                      {speaker.youtube && (
                    <a
                      href={speaker.youtube}
                      className="text-white mx-2"
                      title="YouTube"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube fa-lg"></i>
                    </a>
                  )}
                  {speaker.website && (
                    <a
                      href={speaker.website}
                      className="text-white mx-2"
                      title="Website"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fas fa-globe fa-lg"></i>
                    </a>
                  )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
